import React from 'react';
import CustomerContactInfoComp from './CustomerContactInfoComp';

const CustomerContactInfoCity = props =>
  (
<CustomerContactInfoComp
  {...props}
  autoComplete="address-level2"
  errorMessages={{
    'field_is_required': 'The city field is required',
    'field_is_invalid': 'City is invalid',
  }}
  label="City"
  name="city"
/>
  );

export default CustomerContactInfoCity;
